var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"max-height":"21","max-width":"21","src":"/img/icons/transaction.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }